<template>
  <v-container class="py-10" id="investitionen">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#f0b414">Investitionen</div>
        <h2>Investitionen in der Zukunft</h2>
        <p>
          <b>15%</b> der Organisationen gaben an, dass ihr IT-Budget
          voraussichtlich in diesem Jahr sinken wird. <b>47%</b> gaben an, dass
          ihr IT-Budget ungefähr gleich bleiben wird. Und <b>39%</b> gaben an,
          dass ihr Budget steigen wird. Doch in welchen Bereichen wollen die
          Organisationen investieren? Das scheint vor allem bei Soft- und
          Hardware-Lösungen der Fall zu sein (<b>75%</b>). Jede zweite
          Organisation plant außerdem, in Schulungen zu investieren. Aber nur
          ein Drittel der Organisationen wollen in externe Dienstleister und
          Personal investieren.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Investitionen Bereiche' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Investitionen",
  computed: {
    chartOptions() {
      return {
        chart: {
          polar: true,
          type: "line"
        },
        title: {
          text:
            "Wie viele Organisationen planen Investitionen in den folgenden Bereichen?"
        },
        xAxis: {
          categories: [
            "Software",
            "Hardware",
            "IT Schulungen",
            "IT Personal",
            "Auslagerung von IT"
          ],
          tickmarkPlacement: "on",
          lineWidth: 0,
          gridLineWidth: 1,
          gridLineColor: "rgba(46, 52, 64, .1)",
          allowDecimals: false
        },
        yAxis: {
          gridLineInterpolation: "polygon",
          lineWidth: 0,
          min: 0,
          max: 100,
          gridLineWidth: 1,
          gridLineColor: "rgba(46, 52, 64, .1)",
          allowDecimals: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#d62b03", "#f06914", "#f0b414"],
        series: [
          {
            data: [77.98, 73.94, 50.86, 31.47, 32.41],
            pointPlacement: "on"
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Investitionen",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
